<template>
  <div class="u-pad-v--4 u-fg--black">
    <div class="o-container o-container--responsive">
      <div class="o-layout o-layout--responsive">
        <div class="o-layout__item u-mrgn-top--2 u-mrgn-bottom--5">
          <Breadcrumb :this-page="thisPage" :other-links="otherBreadcrumbLink" />
        </div>
      </div>
      <h1 class="u-txt--bold u-txt--medium u-mrgn-bottom--3">{{ title }}</h1>
      <div class="u-txt--base u-line-height--20" v-html="pageDescription" />
      <div class="u-mrgn-bottom--3">
        <div class="u-txt--fair u-txt--bold u-mrgn-bottom--1">Tokoh Penting</div>
        <div class="o-layout o-layout--responsive u-txt--base">
          <div class="o-layout__item u-4of12">
            Dewan Komisaris
            <ul class="key-person">
              <li v-for="(commisioner, index) in keyPerson.commisioners" :key="index">{{ commisioner }}</li>
            </ul>
          </div>
          <div class="o-layout__item u-4of12">
            Dewan Direksi
            <ul class="key-person">
              <li v-for="(director, index) in keyPerson.directors" :key="index">{{ director }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div class="u-txt--fair u-txt--bold u-mrgn-bottom--1">Alamat</div>
        <div class="o-layout o-layout--responsive u-txt--base">
          <div class="o-layout__item u-4of12">
            <div>{{ address.detail }}</div>
            <div>{{ address.province }}</div>
            <div v-if="address.phone">Phone: {{ address.phone }}</div>
            <div v-if="address.fax">Fax: {{ address.fax }}</div>
          </div>
        </div>
      </div>
      <div><ProductList :investment-manager="imCode" /></div>
      <div><OtherLinkFooter :other-links="otherLinks" /></div>
    </div>
  </div>
</template>

<script>
import ProductList from 'shared/components/desktop/ProductList';
import Breadcrumb from 'shared/components/desktop/Breadcrumb';
import OtherLinkFooter from 'shared/components/desktop/OtherLinkFooter';

export default {
  name: 'InvestmentManagerDetailDesktop',
  components: {
    Breadcrumb,
    ProductList,
    OtherLinkFooter,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    pageDescription: {
      type: String,
      default: '',
    },
    imCode: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    keyPerson: {
      type: Object,
      default: () => ({}),
    },
    address: {
      type: Object,
      default: () => ({}),
    },
    breadcrumbLinks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    thisPage() {
      return this.breadcrumbLinks.find(link => link.isActive);
    },
    otherBreadcrumbLink() {
      return this.breadcrumbLinks.filter(link => !link.isActive);
    },
  },
};
</script>

<style scoped>
.key-person {
  list-style-type: disc;
  list-style-position: outside;
  margin-left: 18px;
}
.key-person > li {
  padding-left: 12px;
}
</style>
